import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetCollection_pointsInvoicesParse_progress_progressId = z.any()
export type TagsGetCollection_pointsInvoicesParse_progress_progressId = z.infer<typeof tagsGetCollection_pointsInvoicesParse_progress_progressId>

export const descriptionGetCollection_pointsInvoicesParse_progress_progressId = z.any()
export type DescriptionGetCollection_pointsInvoicesParse_progress_progressId = z.infer<typeof descriptionGetCollection_pointsInvoicesParse_progress_progressId>

export const paramsGetCollection_pointsInvoicesParse_progress_progressId = z.object({ "progressId": z.string().uuid() })
export type ParamsGetCollection_pointsInvoicesParse_progress_progressId = z.infer<typeof paramsGetCollection_pointsInvoicesParse_progress_progressId>

export const responseGetCollection_pointsInvoicesParse_progress_progressId = z.object({ "payload": z.object({ "progressId": z.string().uuid(), "parseMode": z.union([z.literal("single"), z.literal("bulk")]), "collectionPointType": z.string().optional(), "step": z.union([z.literal("preparing"), z.literal("routing"), z.literal("segmenting"), z.literal("complete"), z.literal("error")]), "totalSegments": z.number().optional(), "processedSegments": z.number().optional(), "currentSegment": z.number().optional(), "updatedAt": z.string().datetime({ offset: true }) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetCollection_pointsInvoicesParse_progress_progressId = z.infer<typeof responseGetCollection_pointsInvoicesParse_progress_progressId>

interface IGetCollection_pointsInvoicesParse_progress_progressId extends BaseMethodType {
  tags: TagsGetCollection_pointsInvoicesParse_progress_progressId,
  description: DescriptionGetCollection_pointsInvoicesParse_progress_progressId,
  params: ParamsGetCollection_pointsInvoicesParse_progress_progressId,
  response: ResponseGetCollection_pointsInvoicesParse_progress_progressId
}
export const URL = '/collection-points/invoices/parse-progress/:progressId'
export const validation = {
  get: {
    tags: tagsGetCollection_pointsInvoicesParse_progress_progressId,
    description: descriptionGetCollection_pointsInvoicesParse_progress_progressId,
    params: paramsGetCollection_pointsInvoicesParse_progress_progressId,
    response: responseGetCollection_pointsInvoicesParse_progress_progressId
  }
}
export interface Collection_pointsInvoicesParse_progress_progressId extends BaseRouteType {
  get: IGetCollection_pointsInvoicesParse_progress_progressId
}